import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

// init card slider
const initCardSlider = () => {

  new Swiper(".ks-card-slider .ks-card-slider-swiper", {
    modules: [Navigation, Pagination],
    speed: 1000,
    loop: false,
    autoHeight: false,
    slidesPerView: 1.5,
    centeredSlides: true,
    watchOverflow: true,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      576: {
        slidesPerView: 1.5
      },
      768: {
        slidesPerView: 3,
        pagination: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      992: {
        slidesPerView: 4,
        pagination: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      1400: {
        slidesPerView: 5,
        pagination: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  });

};

export default initCardSlider;
